import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { PlatformRow } from "namirasoft-job-arranger";
import { NSCard, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component } from "react";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerMenus } from "../JobArrangerMenus";
import { JobArrangerProps } from "../JobArrangerProps";
import { JobArrangerRoutes } from "../JobArrangerRoutes";
import Styles from "./HomePage.module.css";

interface HomePageProps extends NSARouterMakerResult, JobArrangerProps { }

interface HomePageState
{
    platforms: PlatformRow[];
}

export default class HomePage extends Component<HomePageProps, HomePageState>
{
    constructor(props: HomePageProps)
    {
        super(props);
        this.state = { platforms: [] };
    }
    override async componentDidMount()
    {
        try
        {
            let platforms = await this.props.servers.job_arranger.platform.List();
            this.setState({ platforms });
        }
        catch { }
    }
    override render()
    {
        return (
            <JobArrangerLayout
                {...this.props}
                action={{
                    menus: {
                        "Store": [JobArrangerMenus.download()]
                    }
                }}
            >
                <NSAHomePage
                    {...this.props}
                    getChildren={{
                        getChildrenBetween: () =>
                        {
                            return (
                                <>
                                    <NSRow classList={[Styles.row]}>
                                        <NSCard
                                            title="Dashboard"
                                            description="Comprehensive reports, status-based and platform-based, to help you stay informed about your job search progress and activities"
                                            link={{ href: JobArrangerRoutes.Dashboard, target: "_self" }}
                                        />
                                        <NSCard
                                            title="Jobs"
                                            description="Comprehensive reports, status-based and platform-based, to help you stay informed about your job search progress and activities"
                                            link={{ href: JobArrangerRoutes.JobList, target: "_self" }}
                                        />
                                        <NSCard
                                            title="Reasons"
                                            description="Comprehensive reports, status-based and platform-based, to help you stay informed about your job search progress and activities"
                                            link={{ href: JobArrangerRoutes.ReasonList, target: "_self" }}
                                        />
                                    </NSRow>
                                    <NSSpace size={NSSpaceSizeType.SMALL} />
                                    <NSRow classList={[Styles.home_row]}>
                                        {
                                            this.state.platforms.map(platform => (
                                                <NSCard
                                                    key={platform.name}
                                                    title={platform.name}
                                                    image={{ src: platform.icon, alt: platform.name }}
                                                    link={{ href: platform.search, target: "_blank" }}
                                                    classList={[Styles.platform_card]}
                                                />
                                            ))
                                        }
                                    </NSRow>
                                </>
                            )
                        },
                    }}
                />
            </JobArrangerLayout>
        );
    }
}